import { setup } from 'axios-cache-adapter/src';
import { cacheStore } from '../shared/storage';

const axios = setup({
  cache: {
    maxAge: 5 * 60 * 1000,
    store: cacheStore,
  },
});

export default axios;
